import { Container, createStyles, Link, makeStyles, Typography } from "@material-ui/core"
import React from "react"


type Props = {

}

export const FlutterFeatures = (props: Props) => {
    const classes = useStyles({});
    return (
        <div className={classes.section}>
            <Container maxWidth='md'>
                <Typography variant='h2' align='center'
                    className='title' gutterBottom>Here are all the Features</Typography>
                <Typography variant='h6' gutterBottom>🔍 See all vetted profiles, search by city or distance from you</Typography>
                <Typography variant='h6' gutterBottom >💰 No swiping/No paywalls</Typography>
                <Typography variant='h6' gutterBottom>😎 Verified & vetted users</Typography>
                <Typography variant='h6' gutterBottom>🎙 After matching, we help you schedule a phone call and then meet in real life</Typography>
                <Typography variant='h6'>Flutter is built by 1 human so if you have ideas/questions just contact me at <Link href='mailto:getfluttertext@gmail.com'>getfluttertext@gmail.com</Link>. Thanks</Typography>
            </Container>
        </div>
    );
}

const useStyles = makeStyles(theme => createStyles({
    section: {
        padding: theme.spacing(6, 0),
        color: 'white',
        background: theme.palette.secondary.main,
    },
}))